import * as tslib_1 from "tslib";
import { Store, select } from '@ngrx/store';
import { Actions, ofType, ROOT_EFFECTS_INIT, createEffect } from '@ngrx/effects';
import { tap, take, mapTo, switchMap, filter, map, delay, catchError, concatMap, withLatestFrom } from 'rxjs/operators';
import { AuthenticationService, getLink, SirenResponse, ROUTE_PARAM_REGEX, downloadDocument, SirenHttp } from '@awp/http';
import * as dataApi from '@awp/data/api';
import { ApiResponse, ApiLink } from '@awp/quote/models';
import { ActionTypes, DocumentDownloadSuccessAction, DocumentDownloadFailureAction } from './actions';
import { ThemeService } from '@awp/theme';
import { ContentParser } from '@awp/content';
import { getSirenResponse } from '@awp/data/api';
import { of } from 'rxjs';
import { createErrorModel } from '@awp/core/utils';
var AppEffects = /** @class */ (function () {
    function AppEffects(actions$, store, themeService, contentParser, http, authService) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.themeService = themeService;
        this.contentParser = contentParser;
        this.http = http;
        this.authService = authService;
        this.auth$ = createEffect(function () {
            return _this.actions$.pipe(ofType(ROOT_EFFECTS_INIT), concatMap(function (action) { return of(action).pipe(withLatestFrom(_this.store.pipe(select(dataApi.getSirenResponse(ApiResponse.Authenticate))), _this.store.pipe(select(dataApi.getSirenResponse(ApiResponse.ReAuthenticate))))); }), take(1), tap(function (_a) {
                var _b = tslib_1.__read(_a, 3), action = _b[0], authResponse = _b[1], reAuthResponse = _b[2];
                if (authResponse != null) {
                    _this.authService.setAuthResponse(authResponse, reAuthResponse);
                }
                _this.contentParser.context = _this.contentParser.context || {};
                if (authResponse != null) {
                    var pdsUrl = _this.getPdsUrl(authResponse);
                    _this.contentParser.context = tslib_1.__assign({}, _this.contentParser.context, { url: tslib_1.__assign({}, _this.contentParser.context.url, { pdsUrl: pdsUrl }) });
                }
            }));
        }, { dispatch: false });
        this.reset$ = createEffect(function () {
            return _this.actions$.pipe(ofType(ActionTypes.RESET_STATE), mapTo(new dataApi.AuthenticateAction()));
        });
        this.themeChanged$ = createEffect(function () {
            return _this.actions$.pipe(ofType(ActionTypes.APP_THEME_CHANGED), switchMap(function (action) { return _this.themeService.getTheme(); }), tap(function (theme) {
                _this.contentParser.context = _this.contentParser.context || {};
                _this.contentParser.context = tslib_1.__assign({}, _this.contentParser.context, theme, { url: tslib_1.__assign({}, _this.contentParser.context.url, theme.url) });
            }));
        }, { dispatch: false });
        this.sirenAuthResponse$ = createEffect(function () {
            return _this.actions$.pipe(ofType(dataApi.ActionTypes.SIREN_RESPONSE), filter(function (action) {
                return action.payload.response != null
                    && action.payload.response.rel != null
                    && action.payload.response.rel.includes(ApiResponse.Authenticate);
            }), map(function (action) { return action.payload.response; }), tap(function (response) {
                _this.contentParser.context = _this.contentParser.context || {};
                var pdsUrl = _this.getPdsUrl(response);
                _this.contentParser.context = tslib_1.__assign({}, _this.contentParser.context, { url: tslib_1.__assign({}, _this.contentParser.context.url, { pdsUrl: pdsUrl }) });
            }));
        }, { dispatch: false });
        this.downloadDocument$ = createEffect(function () {
            return _this.actions$.pipe(ofType(ActionTypes.DOCUMENT_DOWNLOAD), concatMap(function (action) { return of(action).pipe(withLatestFrom(_this.store.pipe(select(getSirenResponse(ApiResponse.Authenticate))))); }), switchMap(function (_a) {
                var _b = tslib_1.__read(_a, 2), action = _b[0], authResponse = _b[1];
                var auth$ = authResponse == null ? _this.authService.authenticate() : of(authResponse);
                return auth$
                    .pipe(delay(500), switchMap(function (auth) {
                    _this.authService.setAuthResponse(authResponse);
                    var link = getLink(ApiLink.PdsDocument, auth);
                    return downloadDocument(_this.http, 'Pds', link, { route: action.payload }, true)
                        .pipe(map(function (p) { return new DocumentDownloadSuccessAction(); }), catchError(function (err) {
                        console.error('Error download Document');
                        return of(new DocumentDownloadFailureAction(createErrorModel({ err: err, section: 'Document Download', message: 'Error downloading document' })));
                    }));
                }));
            }));
        });
    }
    AppEffects.prototype.getPdsUrl = function (response) {
        var pdsLink = getLink(ApiLink.PdsDocument, response);
        var url = pdsLink != null ? pdsLink.href : null;
        var pdsUrl = url.replace(ROUTE_PARAM_REGEX, function (match, key) {
            if (key === 'clientname') {
                return '{{context.themeId}}';
            }
            else {
                return "{" + match + "}";
            }
        });
        return pdsUrl;
    };
    return AppEffects;
}());
export { AppEffects };
